module.exports = {"platforms":[{"message":"Start Platform","type":"FiniteImmobilePlatform","x":32,"y":416,"width":224,"height":32,"display":{"assetName":"lanterns"}},{"message":"Goal Platform","type":"FiniteImmobilePlatform","x":512,"y":128,"width":224,"height":32,"display":{"assetName":"lanterns"}}],"goal":{"x":672,"y":128},"player":{"x":96,"y":350},"par":1}


//////////////////
// WEBPACK FOOTER
// ./node_modules/json-loader!./levels/beta-2-cut-1.json
// module id = 139
// module chunks = 0